module.exports = __webpack_public_path__ + "static/media/board_Marlene_Street-Forrest.61ec6e8f.jpg";